import axios from "axios";
import router from "@/router";
import { ElMessage } from "element-plus";

const service = axios.create({
	baseURL: "https://v22api.hello-world.cool",
	timeout: 5000, // 请求超时时间
});

service.interceptors.request.use(
	function (config) {
		// 在发送请求之前做些什么, 可以在这里添加请求头等信息
		if (localStorage.getItem("token")) {
			config.headers.Authorization = localStorage.getItem("token");
		}
		return config;
	},
	function (error) {
		// 对请求错误做些什么
		return Promise.reject(error);
	}
);

// 添加响应拦截器
service.interceptors.response.use(
	function (response) {
		const res = response.data;
		if (res.code === "1001") {
			ElMessage.error(res.message);
		}
		if (res.code === "1002") {
			ElMessage.error(res.message);
			router.push({ path: "/login" });
			localStorage.clear();
		}
		return res;
	},
	function (error) {
		// 对响应错误做点什么
		return Promise.reject(error);
	}
);

export default service;
